import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const loginUser = async (username, password) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/login`, {
      username,
      password
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if (response.data && response.data.access_token) {
      return response.data;
    } else {
      throw new Error('No access token received from server');
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      throw new Error('Invalid username or password');
    } else if (error.response && error.response.data && error.response.data.detail) {
      throw new Error(error.response.data.detail);
    } else {
      throw new Error(error.message || 'Login failed');
    }
  }
};

export const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  if (token) {
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  }
  return {};
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('authToken');
};

export const logout = async () => {
  try {
    const token = localStorage.getItem('authToken');
    if (token) {
      // Send logout request to backend
      await axios.post(`${API_BASE_URL}/logout`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
    }
  } catch (error) {
    console.error('Logout request failed:', error);
    // Continue with local logout even if API call fails
  } finally {
    // Always clear local storage
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  }
};

export const requestPasswordReset = async (email) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/forgot-password`, {
      email
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.detail) {
      throw new Error(error.response.data.detail);
    } else if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error(error.message || 'Failed to send password reset email');
    }
  }
};


/**
 * Verify that a password reset token is valid
 * @param {string} token - The reset token from the email link
 * @returns {Promise<{valid: boolean, message: string, username?: string}>}
 */
export const verifyResetToken = async (token) => {
  try {
    const response = await fetch(`${API_BASE_URL}/verify-reset-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error verifying reset token:', error);
    throw error;
  }
};

/**
 * Reset password using a reset token
 * @param {string} token - The reset token from the email link
 * @param {string} newPassword - The new password to set
 * @returns {Promise<{message: string, username: string}>}
 */
export const resetPassword = async (token, newPassword) => {
  try {
    const response = await fetch(`${API_BASE_URL}/reset-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token,
        new_password: newPassword
      })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || error.message || 'Failed to reset password');
    }

    return await response.json();
  } catch (error) {
    console.error('Error resetting password:', error);
    throw error;
  }
};


export const resetPassword1 = async (token, newPassword) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/reset_password`, {
      token,
      new_password: newPassword
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.detail) {
      throw new Error(error.response.data.detail);
    } else if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error(error.message || 'Failed to reset password');
    }
  }
};


